import { positions } from '../../components/kit/Alert/positions';
import { delay, put } from 'redux-saga/effects';

export const SHOW_ALERT = 'SHOW_ALERT';
export const HIDE_ALERT = 'HIDE_ALERT';

export const showAlert = (message, status, position) => ({
  type: SHOW_ALERT,
  message,
  status,
  position,
});

export const showWarningAlert = (message, position) =>
  showAlert(message, 'warning', position);

export const showFailureAlert = (message, position) =>
  showAlert(message, 'failure', position);

export const showInfoAlert = (message, position) =>
  showAlert(message, 'info', position);

export const hideAlert = () => ({
  type: HIDE_ALERT,
});

const initialState = {
  isOpen: false,
  message: '',
  position: positions.TOP,
  status: 'success',
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_ALERT:
      return {
        ...state,
        isOpen: true,
        message: action.message,
        position: action.position || initialState.position,
        status: action.status || initialState.status,
      };
    case HIDE_ALERT:
      return {
        ...state,
        isOpen: false,
      };
    default:
      return state;
  }
}

export function* watchAlert() {
  yield delay(5000);
  yield put(hideAlert());
}
